export default __webpack_public_path__ + "static/media/6.8009905c.jpg";